var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMskuItemColored(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7008_823",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7008_823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33334L0.666672 5.33334L8 1.33334L15.3333 5.33334L8 9.33334ZM8 12L1.05001 8.21668L2.45 7.45001L8 10.4833L13.55 7.45001L14.95 8.21668L8 12ZM8 14.6667L1.05001 10.8833L2.45 10.1167L8 13.15L13.55 10.1167L14.95 10.8833L8 14.6667ZM8 7.81668L12.55 5.33334L8 2.85001L3.45001 5.33334L8 7.81668Z",
    fill: "#824FBA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMskuItemColored);
export default __webpack_public_path__ + "static/media/icon-msku-item-colored.cbcb3501eb9cdc45b507267888a1389a.svg";
export { ForwardRef as ReactComponent };